import React, {useState, useEffect, useRef} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import axios from "axios";
import {InputNumber} from "primereact/inputnumber";

const CostitemListComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity} = useParams();
  const [costitems, setCostitems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const dt = useRef(null);
  const [costSources, setCostSources] = useState([]);
  const [costStatuses, setCostStatuses] = useState([]);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
  });

  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParams)
      apiCall('get', '/api/v2/cost-item' + query)
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setCostitems(response.data.data.items)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        {/* {localStorage.getItem('roles').toString().includes('role_') &&
          <Button icon="pi pi-pencil" className="  p-button-warning p-mr-2"
                  tooltip={t('edit')} tooltipOptions={{position: 'left'}}
                  onClick={() => {
                    if(entity === 'cost-item') {
                      history.push('/inventory/cost-item/update/' + rowData.id)
                    }
                  }}/>
                  
        } */}
        <Button icon="pi pi-eye" className=" p-button p-mr-2"
          tooltip={t('view')} tooltipOptions={{ position: 'left' }}
          onClick={() => {
            if(entity === 'cost-item') {
              history.push('/finance/cost-item/read/' + rowData.id)
            }
          }}/>
        {/* {localStorage.getItem('roles').toString().includes('role_') &&
          <Button icon="pi pi-trash" className="p-button-danger"
                  tooltip={t('delete')} tooltipOptions={{position: 'left'}}
                  onClick={() => {
                    if (window.confirm('A törlés megerősítésére van szükség!')) {
                      setLoading(true);
                      apiCall('delete', '/api/v2/cost-item/' + rowData.id)
                        .then(response => {
                          window.App.toastShow('success', 'Sikeres törlés!');
                          window.App.setState({rerenderCostitemList: Math.random()})
                        })
                        .catch(error => {
                          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                        })
                        .finally(() => {
                          setLoading(false);
                        })
                    }
                  }}
          />
        } */}
      </React.Fragment>
    );
  }

  useEffect(() => {
    apiCall('get', '/api/v2/dictionary/cost-source')
      .then(response => {
        const d = response.data?.data || response.data;
        const list = Array.isArray(d) ? d : (d?.data || []);
        setCostSources(list || []);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      });

    apiCall('get', '/api/v2/dictionary/cost-status')
      .then(response => {
        const d = response.data?.data || response.data;
        const list = Array.isArray(d) ? d : (d?.data || []);
        setCostStatuses(list || []);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      });
  }, []);

  useEffect(() => {
    loadLazyData();
  }, [lazyParams, window.App.state.rerenderCostitemList])

  return (
    <>
      <DataTable size={localStorage.getItem('scale')}
                 emptyMessage={t('noResults')}
                 value={costitems} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
                 onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                 onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
                 paginatorTemplate={pager} rows={rows}
                 autoLayout={true}
                 filterDisplay="row"
                 responsiveLayout="scroll"
                 stripedRows
                 ref={dt}
                 dataKey="id"
      >

        <Column field="name" header={t('columnName')} bodyClassName="col-body-font-bold" sortable filter
          body={(rowData) => {
            const text = rowData?.name ?? '';
            const source = String(rowData?.source ?? '');
            const receiptId = rowData?.receipt?.id ?? rowData?.receipt_id ?? null;
            const isReceiptLine = source === 'RECEIPT_LINE';
            if (isReceiptLine && receiptId) {
              return (
                <a href="#" onClick={(e) => { e.preventDefault(); history.push('/finance/receipt/read/' + receiptId); }}>
                  {text}
                </a>
              );
            }
            return <>{text}</>;
          }}
        ></Column>
        <Column field="source" header={t('columnSource')} sortable filter filterMatchMode="equals"
                body={(rowData) => {
                  const key = rowData.source;
                  const found = costSources?.find(x => x.key === key);
                  return <>{found?.value || key || ''}</>;
                }}
                filterElement={(options) => (
                  <Dropdown value={options.value}
                            options={costSources}
                            optionLabel="value"
                            optionValue="key"
                            placeholder={t('selectPlaceholder')}
                            showClear
                            onChange={(e) => options.filterApplyCallback(e.value)}
                            appendTo={document.body}
                  />
                )}
        ></Column>

        <Column field="status" header={t('columnStatus2')} sortable filter filterMatchMode="equals"
                body={(rowData) => {
                  const key = rowData.status;
                  const found = costStatuses?.find(x => x.key === key);
                  return <>{found?.value || key || ''}</>;
                }}
                filterElement={(options) => (
                  <Dropdown value={options.value}
                            options={costStatuses}
                            optionLabel="value"
                            optionValue="key"
                            placeholder={t('selectPlaceholder')}
                            showClear
                            onChange={(e) => options.filterApplyCallback(e.value)}
                            appendTo={document.body}
                  />
                )}
        ></Column>


        <Column field="amount" header={t('columnAmount')} sortable filter filterMatchMode="between"
          body={(rowData) => {
            const amount = rowData?.amount;
            const currency = rowData?.currency || 'HUF';
            const num = Number(amount);
            if (amount === null || amount === undefined || Number.isNaN(num)) return <></>;
            return <>{window.App.currencyFormatter(currency, num)}</>;
          }}
          filterElement={(options) => (
            <div className="p-d-flex p-ai-center" style={{gap: '0.5rem'}}>
              <InputNumber value={options.value?.[0] ?? null}
                            allowEmpty
                            placeholder={t('fromPlaceholder')}onValueChange={(e) => options.filterApplyCallback([e.value ?? null, options.value?.[1] ?? null])}
                            mode="decimal"
                            minFractionDigits={0}
                            maxFractionDigits={9}
              />
              <InputNumber value={options.value?.[1] ?? null}
                            allowEmpty
                            placeholder={t('toPlaceholder')}onValueChange={(e) => options.filterApplyCallback([options.value?.[0] ?? null, e.value ?? null])}
                            mode="decimal"
                            minFractionDigits={0}
                            maxFractionDigits={9}
              />
            </div>
          )}
        ></Column>



        <Column body={actionBodyTemplate} className={"p-py-0 p-text-right p-text-nowrap"}></Column>
      </DataTable>
    </>
  )
}
export default withTranslation('common')(CostitemListComponent);
